import styled from 'styled-components';

export const OptionsWrapper = styled.div`
  position: relative;
  width: 350px;
`;
